<template>
  <div>
        <el-card>

            <div slot="header">
                <router-link :to="{path:'/serverAdd',query:{callback:fetchData}}">
                    <el-button type="primary" v-w-role="'ITSM-0232'">新增服务器</el-button>
                </router-link>

            </div>

            <el-table v-loading="listLoading" :data="list" border="">

                <el-table-column label="salt-id" prop='hostname'>
                    <!-- <template slot-scope='scope'>
                        <router-link :to="{ path: '/detailServer', query: { host_id: scope.row.id } }">
                            <el-button type='text'>{{ scope.row.hostname }}</el-button>
                        </router-link>
                    </template> -->
                </el-table-column>

                <el-table-column label="IP" prop='ip' min-width='100'></el-table-column>

                <el-table-column label="类型" prop='type'>
                    <template slot-scope='scope'>
                        {{tableVal(scope.row.type,host_type)}}
                    </template>
                </el-table-column>
                
                <el-table-column label="配置">
                    <template slot-scope='scope'>
                        <p>HDD: {{scope.row.disk}} </p>
                        <p>OS: {{scope.row.os}} </p>
                        <p>CPU: {{scope.row.cpu}} </p>
                        <p>DDR3: {{scope.row.memory}} </p>
                    </template>
                    
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope='scope'>
                        <router-link :to="{path:'/serverAdd',query:{type:'edit',serverId:scope.row.id,callback:fetchData}}">
                            <el-button type="text" v-w-role="'ITSM-0233'">编辑</el-button>
                        </router-link>
                        <el-button type="text" class="table-del-btn" @click="handleDel(scope.row.id)" v-w-role="'ITSM-0234'">删除</el-button>
                    </template>

                </el-table-column>

            </el-table>
            
            <el-pagination
             @size-change="handleSizeChange"
             @current-change="handleCurrentChange"
             :current-page="listQuery.page_num"
             :page-sizes="[10, 20, 30, 40]"
             :page-size="listQuery.page_size"
             layout="total, sizes, prev, pager, next, jumper"
             :total="total">
            </el-pagination>

      </el-card>
      
  </div>
</template>

<script>
    import services from './server.services'
    export default {
        data() {
            return {
                list: null,
                total: 0,
                listLoading: true,
                listQuery: {
                    page_num: 1,
                    page_size: 10
                },
                env: {
                    0: '开发',
                    1: '测试',
                    2: '预生产',
                    3: '生产',
                    4: '新能源测试'
                },

            }
        },
    
        mounted() {

            this.fetchData()
        },

        computed: {
            dictionary() {
                return this.$store.state.dictionary2
            },
            host_type() {
                return this.dictionary.host_type
            }
        },

        methods: {

            // 请求数据
            fetchData() {
                this.listLoading = true
                let content = {
                    pageIndex: this.listQuery.page_num,
                    pageSize: this.listQuery.page_size
                }
                services.serverList({ ...content }).then(response => {
                    this.list = response.list
                    this.total = response.total
                    this.listLoading = false
                })
            },
            
            // 删除文件
            handleDel(key) {
                this.$confirm('此操作将删除该服务器, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    services.delServer({ id: key })
                        .then(response => this.fetchData())
                        .catch(err => this.$message.error(err.message))
                }).catch(() => {
                    return false
                })
            },
            
            // 跳转编辑
            handleUpdate(key) {
                this.$router.push({
                    path: '/appcenterServerAdd',
                    query: {
                        type: 'edit',
                        server_id: key,
                        callback: this.fetchData
                    }
                })
            },

            // 页数改变时
            handleSizeChange(val) {
                let pages = Math.ceil(this.total / val)
                this.listQuery.page_size = val
                if(this.listQuery.page_num > pages ){
                    this.listQuery.page_num  = 1
                }
                this.fetchData()
            },

            // 页码改变时
            handleCurrentChange(val) {
                    this.listQuery.page_num = val
                    this.fetchData()
            },
            // 根据数据字典取值
            tableVal(value, arr) {
                if(!arr) return '无'
                if(arr && arr.length == 0) return "无"
                let res = arr.filter(item => item.default == value)
                let str = ""
                if(!res.length) str =  "无"
                str = res[0].cname
                return str
            },

            fmtOtherIP(row, column) {
                return row.other_ip === '1' ? '是' : '否'
            },

            fmtEnv(row, column) {
                return this.env[row.env]
            },

            fmtStatus(row, column) {
                return row.status === 0 ? '默认状态' : row.status
            }
        }
    }
</script>
